import { BaseSymconObject } from '../interfaces'
import { KnockautHandler } from '../knockautHandler'

const LICENSE_SUBSCRIPTION_IDENT = 'LicenseSubscription'

export interface UtilControlData {
  attributes: {}
  configuration: {
    EnableRequestLicenseData: boolean
    EnableSendUsageDat: boolean
    LastCheckedVersion: string
  }
  connectionID: number
  lastChange: number
  moduleID: string
  moduleName: string
  moduleType: number
  status: number
}

export interface UtilControlModule extends BaseSymconObject {
  id: number
  data: UtilControlData
}

export class UtilControlHandler {
  private _utilControl: UtilControlModule
  private _knockautHandler: KnockautHandler

  constructor(
    knockautHandler: KnockautHandler,
    utilControl: UtilControlModule
  ) {
    this._utilControl = utilControl
    this._knockautHandler = knockautHandler
  }

  get utilControlId() {
    return this._utilControl.id
  }

  /**
   * Enables the option that license data can be requested
   */
  async enableRequestLicenseData() {
    const config = JSON.parse(
      await this._knockautHandler.getConfiguration(this.utilControlId)
    )
    if (!config.EnableRequestLicenseData) {
      config.EnableRequestLicenseData = true
      await this._knockautHandler.setConfigurationAndApply(
        this.utilControlId,
        config
      )
    }
  }

  /**
   * Returns the date until which the subscription is valid
   * @returns Subscription end date
   */
  async getLicenseSubscriptionDate(): Promise<Date | null> {
    await this.enableRequestLicenseData()
    const variables = this._knockautHandler.getVariablesOfInstance(
      this.utilControlId
    )
    for (const variable of variables) {
      if (variable.ident === LICENSE_SUBSCRIPTION_IDENT) {
        let unixTimestamp = variable.data.value as number
        if (unixTimestamp === 0) {
          await this.requestLicenseData()
          unixTimestamp = this._knockautHandler.getObjectById(variable.id).data
            .value as number
        }
        return new Date(unixTimestamp * 1000)
      }
    }
    return null
  }

  async requestLicenseData() {
    await this._knockautHandler.parseKnockautResponse('UC_RequestLicenseData', [
      this.utilControlId,
    ])
    await this._knockautHandler.refreshTree()
  }
}
